import styled, { keyframes } from 'styled-components';
import * as colors from 'Styles/colors';
import { BORDER_RADIUS } from '../Card/Card.styled';
import { Button as StyledButton } from '../Button/Button.styled';

const LARGE_CTA_PADDING = '13px 16px';
const MEDIUM_CTA_PADDING = '10px 16px';
const SMALL_CTA_PADDING = '6px 16px';

const dropdown = keyframes`
  from {
    transform: translateY(16px);
  }

  to {
    transform: translateY(0);
  }
`;

export const Reveal = styled.div`
  border-radius: ${BORDER_RADIUS};
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  /* grey20 with opacity */
  background: rgb(245, 248, 248, 0.95);
  border: 1px solid ${colors.grey40};
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  min-height: 100%;
  animation: ${dropdown} 100ms cubic-bezier(0.25, 1, 0.25, 1);
`;

export const Cta = styled(StyledButton)`
  margin: 4px 8px 8px 0;
  overflow-wrap: anywhere;
  opacity: 1;
  min-width: auto;
  /* When text wraps, specifying a top/bottom padding will keeps wrapping text away from the edges. */
  ${({ size = 'small' }) => {
    if (size === 'large') return `padding: ${LARGE_CTA_PADDING};`;
    if (size === 'medium') return `padding: ${MEDIUM_CTA_PADDING};`;
    if (size === 'small') return `padding: ${SMALL_CTA_PADDING};`;
  }}

  &:last-of-type {
    margin-right: 0px;
  }
`;

export const Ctas = styled.div`
  align-items: center;
  border-radius: ${BORDER_RADIUS};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
  padding: ${({ $responsiveStyleSize }) =>
    $responsiveStyleSize === 'mega' ? '24px' : '12px'};

  ${Cta} {
    margin: 8px 0 0 0;
    max-width: 275px;
    width: 100%;
    text-align: center;
  }

  ${Cta}:first-of-type {
    margin-top: 0;
  }
`;

export const Backdrop = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  background-color: ${colors.grey20};
  opacity: 0.5;
`;
